import Vue from "vue";
import ajax from "./server";

Vue.use(ajax);
const self = new Vue();

class Api {
  host;
  apiPrefix;
  constructor() {
    this.host = `${location.protocol}//${location.host}`;
    if (window.apiPrefix) {
      const prefix = window.apiPrefix.replace(/\//g, "");
      this.apiPrefix = prefix;
    } else {
      this.apiPrefix = window.env == "debug" ? "cp" : "cp";
    }
  }

  /**
   * fake login
   */
  async login(data) {
    const url = `${this.host}/${this.apiPrefix}/api/child/un/login`;
    const response = await self.$http.post(
      url,
      // { "username": "00000072", "password": "admin" }
      { id: data.id, password: data.password, isPc: false }
    );
    return response;
  }

  async profile() {
    const url = `${this.host}/${this.apiPrefix}/api/child/index/myprofile`;
    const response = await self.$http.get(url);
    return response;
  }

  async allList(data, page) {
    const url = `${this.host}/${
      this.apiPrefix
    }/api/child/work/search?page=${page}&size=12&sort=w.created,desc`;
    const response = await self.$http.post(url, data);
    return response;
  }
  async allBySchool(data, page) {
    const url = `${this.host}/${
      this.apiPrefix
    }/api/child/work/searchBySchool?page=${page}&size=12&sort=w.created,desc`;
    const response = await self.$http.post(url, data);
    return response;
  }

  async selfList(data, page) {
    const url = `${this.host}/${
      this.apiPrefix
    }/api/child/work/searchown?page=${page}&size=12&sort=w.created,desc`;
    const response = await self.$http.post(url, data);
    return response;
  }
  async getAreaCode(pcode) {
    const url = `${this.host}/${this.apiPrefix}/api/base/area/` + pcode;
    const response = await self.$http.get(url);
    return response;
  }
  async register(data) {
    const url = `${this.host}/${this.apiPrefix}/api/child/un/register`;
    const response = await self.$http.post(url, data);
    return response;
  }
  async queryAllSchool(data) {
    const url = `${this.host}/${this.apiPrefix}/api/child/org/getAllSchool`;
    const response = await self.$http.post(url, data);
    return response;
  }
  async getClassList(eid) {
    const url =
      `${this.host}/${this.apiPrefix}/api/child/org/getClassSelect?eid=` + eid;
    const response = await self.$http.get(url);
    return response;
  }
  async delWorkEntity(uid) {
    const url = `${this.host}/${this.apiPrefix}/api/child/work/delWork/` + uid;
    const response = await self.$http.get(url);
    return response;
  }
  async loginOut() {
    const url = `${this.host}/${this.apiPrefix}/api/logout`;
    const response = await self.$http.get(url);
    return response;
  }
  async changePwdAjax(oldPwd, newPwd) {
    const data = {
      oldPassword: oldPwd,
      newPassword: newPwd,
    };
    const url = `${this.host}/${this.apiPrefix}/api/base/account/changepwd`;
    const response = await self.$http.put(url, data);
    return response;
  }
  async getAccountInfo() {
    const url = `${this.host}/${this.apiPrefix}/api/child/account/getSelfInfo`;
    const response = await self.$http.get(url);
    return response;
  }

  async updataAccountInfo(data) {
    const url = `${this.host}/${
      this.apiPrefix
    }/api/child/account/updataAccountInfo`;
    const response = await self.$http.post(url, data);
    return response;
  }
  async queryByStudent(data, page, size) {
    // {keyword:""，classUid：""，isFinish："Y"/"N"}
    const url = `${this.host}/${
      this.apiPrefix
    }/api/child/course/queryByStudent?page=${page}&size=${size}`;
    const response = await self.$http.post(url, data);
    return response;
  }
}

export default Api;
